import {
  ButtonContainer,
  HiddenInput,
  IRfidAsset,
  RfidCardStatusTypes,
  Form,
  SpacerSizeTypes,
  TextLevel,
  useStore,
  Spacer,
  Button,
} from '@envision/ev-ui-component-library'
import api from 'api/api'
import RfidNumber from 'components/RfidNumber'
import { TYPE_ERROR, TYPE_SUCCESS } from 'components/Toast'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { openToast } from 'store/toast'

interface Props {
  id: string
  status: RfidCardStatusTypes
  type: string
  onOptimisticUpdate: (cardId: string, newStatus: RfidCardStatusTypes) => void
}
function UpdateRfidForm({ id, status, type, onOptimisticUpdate }: Props) {
  const { t } = useTranslation(['rfid', 'toast'])
  const dispatch = useDispatch()

  const formMethods = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
  })
  const { reset } = formMethods
  const [eventEmitter] = useStore.eventEmitter()

  const updateStatus = (data: IRfidAsset): Promise<void> => {
    const previousStatus = status
    onOptimisticUpdate(id, RfidCardStatusTypes.ACTIVE)
    return api.assets
      .updateRFIDStatus(data.id)
      .then((resp) => {
        if (resp && (resp.status === 200 || resp.status === 202)) {
          dispatch(
            openToast(
              TYPE_SUCCESS,
              t('external_rfid_form_toast_update_success')
            )
          )
          reset()
          eventEmitter.emit('closeModal', { id: id })
        } else {
          onOptimisticUpdate(id, previousStatus)
          dispatch(
            openToast(TYPE_ERROR, t('external_rfid_form_toast_update_error'))
          )
        }
      })
      .catch(() => {
        onOptimisticUpdate(id, previousStatus)
        dispatch(
          openToast(TYPE_ERROR, t('external_rfid_form_toast_update_error'))
        )
      })
  }

  return (
    <>
      {status === RfidCardStatusTypes.ORDERED && (
        <>
          <TextLevel
            alignment="center"
            fontStyleResponsive={['md', 'md', 'md']}
          >
            {t('external_rfid_modal_description')}
          </TextLevel>
          <Spacer size={SpacerSizeTypes.XL} />

          <Form onSubmit={updateStatus} formMethods={formMethods}>
            <HiddenInput value={id} id="id" formMethods={formMethods} />
            <HiddenInput
              value={RfidCardStatusTypes.ACTIVE}
              id="status"
              formMethods={formMethods}
            />
            <HiddenInput value={type} id="type" formMethods={formMethods} />
            <RfidNumber isRequired formMethods={formMethods} />
            <Spacer size={SpacerSizeTypes.XL} />
            <ButtonContainer alignment="center">
              <Button type="submit">
                {t('external_rfid_button_activate_card')}
              </Button>
            </ButtonContainer>
          </Form>
        </>
      )}

      {status === RfidCardStatusTypes.ACTIVE && (
        <>
          <TextLevel
            alignment="center"
            color="text-information-success-100"
            fontStyleResponsive={['5', '5', '5']}
          >
            {t('external_rfid_modal_success')}
          </TextLevel>
          <Spacer size={SpacerSizeTypes.XL} />
          <TextLevel
            alignment="center"
            fontStyleResponsive={['md', 'md', 'md']}
          >
            {t('external_rfid_modal_description_success')}
          </TextLevel>
          <Spacer size={SpacerSizeTypes.XL} />
          <ButtonContainer alignment="center">
            <Button
              ariaLabel="close"
              onClick={() => eventEmitter.emit('closeModal', { id: id })}
            >
              {t('external_rfid_modal_button_done')}
            </Button>
          </ButtonContainer>
        </>
      )}
    </>
  )
}

export default UpdateRfidForm
